/**
 * The merchant-facing names for a section's type and width, in one place.
 *
 * The section editor's Basic tab names these in its dropdowns and the Sections picker panel names
 * them in its list. A label that drifted between the two would read as two different features, and
 * the picker exists precisely so a merchant can recognise the section they are about to open.
 */
export const SECTION_TYPE_LABELS: Record<string, string> = {
    featured: 'Featured Products',
    bundles: 'Bundles',
    dynamicProductListing: 'Dynamic Product Listings',
    savedSearches: 'Saved Searches',
    selectedProducts: 'Selected Products',
    categoriesSegments: 'Categories/Segments',
    interest: 'Recommended For You',
    promos: 'On Promotion',
    selectedPromos: 'Selected Promotions',
    singleProduct: 'Single Product',
    video: 'Video',
    richText: 'Rich Text',
    banner: 'Banner',
    divider: 'Divider',
};

/** Widest first, so the list reads as a shrinking column. `full` is the absent/default width. */
export const SECTION_WIDTH_LABELS: Record<string, string> = {
    full: 'Full',
    threeQuarters: 'Three Quarters',
    twoThirds: 'Two Thirds',
    half: 'Half',
    third: 'Third',
    quarter: 'Quarter',
};

/**
 * A section's type as the merchant sees it. An unrecognised type falls back to its raw value rather
 * than to a generic word — a store carrying a type this build doesn't know about should say so.
 */
export const sectionTypeLabel = (type?: string): string => (type && SECTION_TYPE_LABELS[type]) || type || 'Section';

/** A section's width as the merchant sees it. Absent = the historical full-width default. */
export const sectionWidthLabel = (width?: string): string => SECTION_WIDTH_LABELS[width ?? 'full'] ?? width ?? 'Full';
